import { Engine1Proxy, ConciergeProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import ProcessManager from '../../../Common/Managers/ProcessManager'

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_DATOS_PROCESOS_DATA = "GET_DATOS_PROCESOS_DATA";
export const GET_DATOS_PROCESOS_DATA_RESULT = "GET_DATOS_PROCESOS_DATA_RESULT";
export const SET_USER_FUNCTIONS = "SET_USER_FUNCTIONS";
export const ORDER_COLUMN_FROM_LISTA = "ORDER_COLUMN_FROM_LISTA";
export const SET_CHECK_ACTIVE = "SET_CHECK_ACTIVE";
export const CONFIGURACION_PROCESOS_REDIRECT_EDITAR_CONFIGURACION_PROCESO = "CONFIGURACION_PROCESOS_REDIRECT_EDITAR_CONFIGURACION_PROCESO"
export const ROUTE_TO_CONFIGURACION_PROCESO = "ROUTE_TO_CONFIGURACION_PROCESO";
export const INITIAL_STATE = "INITIAL_STATE";
export const SELECT_TAB = "SELECT_TAB";
export const CONFIGURACIONPROCESOS_FILTRAR_PROCESOS = "CONFIGURACIONPROCESOS_FILTRAR_PROCESOS";
export const LOADING_CONFIGURACIONPROCESOS = "LOADING_CONFIGURACIONPROCESOS";

let _tarjetas;
let _dispatch;
let _userFunctions;
let userFunctions = [];
let userFeatures = [];

/**
 * 
 * @param {any} id
 * @param {any} currentScope
 * @param {any} cuenta
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    //const { UserId, ProductCode, CategoryCode, ProgramCode } = currentScope;

    return (dispatch, getState) => {
        const state = getState();

        _dispatch = dispatch;

        _dispatch({ type: LOADING_CONFIGURACIONPROCESOS, valor: true });
        dispatch({ type: GET_DATOS_PROCESOS_DATA });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenData(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

export function orderColumn(columnIndex) {
    LogHelper.In(orderColumn.name, columnIndex);
    return (dispatch, getState) => {
        dispatch({ type: ORDER_COLUMN_FROM_LISTA, columnIndex: columnIndex });
    }
}

export function setCheckActive(value, procesos) {
    LogHelper.In(setCheckActive.name, value, procesos);

    return (dispatch, getState) => {
        let inputBuscador = getState().configuracionProcesos?.inputBuscador;
        let todosProcesos = getState().configuracionProcesos?.procesosAll;

        let procesosAFiltrar = value ? todosProcesos.filter( x => {return x.EstaActivo}) : todosProcesos;

        let procesosFiltrados = filtrarProcesos(procesosAFiltrar, inputBuscador)

        dispatch({ type: SET_CHECK_ACTIVE, value, procesos: procesosFiltrados });
    }
}

/**
 * 
 * @param {any} id
 * @param {any} dispatch
 */
export function routeToEditarConfiguracionProceso(id, dispatch) {
    LogHelper.In(routeToEditarConfiguracionProceso.name, id, dispatch);

    return (dispatch) => {
        _routing(id, ROUTE_TO_CONFIGURACION_PROCESO, dispatch);
    }
}

export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE });
    }
}

/**
 * Selección de tab de administradoras
 * @param {any} id
 */
export function selectTab(id) {
    //LogHelper.In(selectTab.name, id);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SELECT_TAB, selectedId: id });
    }
}

/*************************************************************************************************************************************************************** 
*************************************************************************************************************************************************************** */

function _loadScreenData(data) {
    //let funcionesDelUsuario = JSON.parse(JSON.stringify(data.PROCESOS));


    let param;
    let functionsAllowed = [];

    //funcionesDelUsuario.forEach(p => { functionsAllowed[p.Codigo_Funcion] = true  });

    _userFunctions = functionsAllowed;

    param = { 'Opcion': 1 }

    Engine1Proxy.AddDataSourcesRequests(param, 'GET_PROCESOS', 'Get', 'Tarjetas', 'PROCESOS', null, 'User', true);

    Engine1Proxy.Execute((data) => _loadProcesosData(data), null, null, "PROCESOS");

    _dispatch({ type: SET_USER_FUNCTIONS, _userFunctions });
    _dispatch({ type: GET_DATOS_PROCESOS_DATA });
}

function _loadProcesosData(data) {
    LogHelper.In(_loadProcesosData.name, data);    

    let procesos = JSON.parse(data.GET_PROCESOS).Recordset0.Rows;
    let administradoras = JSON.parse(data.GET_PROCESOS).Recordset1.Rows;
    let administratorSelected;

    administradoras.map((marca) => {
        if (marca.Codigo == "MASTER")
            administratorSelected = marca.Id;
    });

    let result = {
        'procesos': procesos,
        'administratorSelected': administratorSelected,
        'administradorasActivas': administradoras
    }

    //Realizo dispatch
    _dispatch({ type: GET_DATOS_PROCESOS_DATA_RESULT, result: result });
    _dispatch({ type: LOADING_CONFIGURACIONPROCESOS, valor: false });
}


/**
 * Funcion encargada del ruteo.
 * @param {any} params
 * @param {any} option
 * @param {any} dispatch
 */
function _routing(params, option, dispatch) {
    LogHelper.In(_routing.name, params, option, dispatch);

    if (params) {
        params = JSON.stringify(params);
    }

    const redirectLocation = ProcessManager.GetNextStep("ConfiguracionProcesos", option, params) + "/" + params;

    dispatch({ type: ROUTE_TO_CONFIGURACION_PROCESO, data: redirectLocation })
}

function filtrarProcesos(procesos, valorInput) {
    let procesosFiltradosBuscador = [];

    if(valorInput){
        let procesosFiltradosNombre = procesos.filter( function(p) {
            let procesosFiltrados = p["NombreProceso"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return procesosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

        let procesosFiltradosDescripcion = procesos.filter( function(p) {
            let procesosFiltrados = p["DescripcionProceso"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return procesosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

         let procesosMergeados = [...procesosFiltradosNombre, ...procesosFiltradosDescripcion];

         procesosFiltradosBuscador = [... new Set(procesosMergeados)];
    }
    else {
        procesosFiltradosBuscador = procesos;
    }

    return procesosFiltradosBuscador;
}

export function buscarProcesos(procesos, valorInput) {
    let procesosFiltradosBuscador = [];

    procesosFiltradosBuscador = filtrarProcesos(procesos, valorInput);

    return (dispatch) => {
        _dispatch({ type: CONFIGURACIONPROCESOS_FILTRAR_PROCESOS, procesosFiltradosBuscador, valorInput });
    }
}